import React from 'react'
import ApprovalPendingList from '../../UserView/ApprovalPendingList'
import { CommonHeader } from '../../../../components/commons'

const AllUsersApprovalPendingList = () => {
  return (
    <>
      <div className='row'>
        <div className='col-md-6 mb-3'>
          <CommonHeader
            title='All Users Approval Pending Scheduling'
          />
        </div>
      </div>
      <ApprovalPendingList type="approvalPendingReport"/>
    </>
  )
}

export default AllUsersApprovalPendingList